import React from "react";
import { Routes, Route } from "react-router-dom";
import AuthStyleWrapper from "components/ui/auth-style-wrapper";
import ManageProfile from "self-service/account/manage-profile";

const setNameTitle = `<h5>Welcome Back</h5>
<p>
Before you log in please can you share the below details with us so we can improve your experience.
</p>`;

const AccountLayout = () => {
    return (
        <AuthStyleWrapper>
            <Routes>
                <Route path="manage-profile" element={<ManageProfile />} />
                <Route path="set-name" element={<ManageProfile cssClassName="set-name" title={setNameTitle} />} />
            </Routes>
        </AuthStyleWrapper>
    )
}

export default AccountLayout;
